import { useFailureStore } from '@/store/useFailureStore';
import { paths } from '@/constants';
import { FailureScreen } from './FailureScreen';
import { offersDashboardExit } from './failureScreenExits';

/**
 * App-root host for store-driven failures — a screen-breaking 5xx from the
 * QueryClient cache callback. Renders `FailureScreen` full-screen over the
 * app (it is `position: fixed`), so the user is never left on a dead screen.
 *
 * Render crashes and route errors do NOT come through here — the error
 * boundaries render `FailureScreen` directly in place of the dead subtree.
 */
export function GlobalFailureScreen() {
  const failure = useFailureStore((s) => s.failure);

  if (!failure) return null;

  return (
    <FailureScreen
      traceId={failure.traceId}
      report={failure.report}
      onTryAgain={() => window.location.reload()}
      onDashboard={
        offersDashboardExit()
          ? () => {
              useFailureStore.getState().clear();
              window.location.assign(paths.root);
            }
          : undefined
      }
    />
  );
}
